import { Panel } from "primereact/panel";
import * as generic from "../../../../../components/Generico";
import { EstadoPatrimonial } from "../../../../../components/trust/EstadoPatrimonial";
import { InfoLaboralClientePj } from "../../../../../models/trust/clientepj/InfoLaboralClientePj";
import { useForm } from "react-hook-form";
import { ClientePjService } from "../../../../../service/trust/ClientePjService";
import { InputComponent } from "../../../../../components/InputComponent";
import { useEffect, useState } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { CatalogoService } from "../../../../../service/CatalogoService";
import { BottomActionBar } from "../../../../../components/ui/BottomActionBar";
import { InputActividadEconomica } from "../../../../../components/ui/Formularios/InputActividadEconomica";

export const InfoLaboralPatrimonio = ({ toast, id, permss, catalogos, handlePrev, handleNext, nuevoCliente, soloLectura }) => {

    const omodel = new InfoLaboralClientePj();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue } = useForm({ defaultValues, shouldTrim: true, mode: 'onTouched' });
    const clientePjServicio = new ClientePjService();
    const catalogoService = new CatalogoService();
    const { inDrop, inCalendar, inText, inNumber } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [ecuadorEmpresa, setEcuadorEmpresa] = useState(false);
    const [ciudadesEmpresa, setCiudadesEmpresa] = useState([]);
    const [ecuadorBien, setEcuadorBien] = useState(false);
    const [ciudadesBien, setCiudadesBien] = useState([]);
    const [ecuadorCanal, setEcuadorCanal] = useState(false);
    const [ciudadesCanal, setCiudadesCanal] = useState([]);

    useEffect(() => {
        if (id) {
            editFicha();
        } else {
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [id]);

    const onSubmit = (data) => {
        setIsSaving(true);
        data.seccion = 'seccion2';
        data.id = id;
        data.ec = catalogos?.ecuador;
        data.fecha_inicio_laboral = generic.dateToString(data.fecha_inicio_laboral);

        clientePjServicio.editarCliente(data).then(res => {
            nuevoCliente(res.data);
            generic.funcSuccess(res, toast);
            handleNext();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const editFicha = () => {
        setIsLoading(true);
        clientePjServicio.consultarCliente(id, { seccion: 'seccion2' }).then(res => {
            const _cli = res.data.cliente;
            if (!_cli) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }
            // Lógica para cargar ciudades si la empresa está en Ecuador
            setEcuadorEmpresa(_cli.pais_empresa?.cat_id === catalogos?.ecuador?.cat_id);
            if (res.data.ciudades_empresa !== undefined) {
                setCiudadesEmpresa(res.data.ciudades_empresa)
            };

            setEcuadorBien(_cli.pais_bien?.cat_id === catalogos?.ecuador?.cat_id);
            if (res.data.ciudades_bien !== undefined) {
                setCiudadesBien(res.data.ciudades_bien);
            }

            setEcuadorCanal(_cli.pais_canal?.cat_id === catalogos?.ecuador?.cat_id);
            if (res.data.ciudades_canal !== undefined) {
                setCiudadesCanal(res.data.ciudades_canal);
            }

            _cli.fecha_inicio_laboral = generic.stringToDate(_cli.fecha_inicio_laboral);
            reset(generic.renewValues(_cli, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const onChangePaisEmpresa = (e) => {
        setEcuadorEmpresa(e.value?.cat_id === catalogos?.ecuador?.cat_id);
        setValue('provincia_empresa', null);
        setValue('ciudad_empresa', null);
        setValue('ciudad_empresa_txt', '');
        setCiudadesEmpresa([]);
    }

    const onChangeProvinciaEmpresa = (e) => {
        setValue('ciudad_empresa', null);
        if (!e?.value) { setCiudadesEmpresa([]); return; }
        // Consultar ciudades por el ID de la provincia seleccionada
        catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudadesEmpresa(res.data));
    }

    const onChangePaisBien = (e) => {
        setEcuadorBien(e.value?.cat_id === catalogos?.ecuador?.cat_id);
        setValue('provincia_bien', null);
        setValue('ciudad_bien', null);
        setCiudadesBien([]);
    };

    const onChangeProvinciaBien = (e) => {
        setValue('ciudad_bien', null);
        if (!e?.value) { setCiudadesBien([]); return; }
        catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudadesBien(res.data));
    };

    const onChangePaisCanal = (e) => {
        setEcuadorCanal(e.value?.cat_id === catalogos?.ecuador?.cat_id);
        setValue('provincia_canal', null);
        setValue('ciudad_canal', null);
        setCiudadesCanal([]);
    };

    const onChangeProvinciaCanal = (e) => {
        setValue('ciudad_canal', null);
        if (!e?.value) { setCiudadesCanal([]); return; }
        catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudadesCanal(res.data));
    };

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <div className="p-fluid">

            <Panel header={generic.renderPanelHeader('D', 'INFORMACIÓN LABORAL Y FINANCIERA DEL REPRESENTANTE LEGAL', 'pi pi-briefcase')} className="panel-ficha shadow-1 mb-4">
                <form id="datosLaboralesForm" onSubmit={handleSubmit(onSubmit, onError)}>
                    <div className="formgrid grid p-2">
                        {inDrop('tipo_relacion_laboral_rep', catalogos?.tipo_relacion_laboral, { lab: omodel.optionLabel }, 6)}
                        {inText('profesion', { icon: 'pi pi-book' }, 6)}

                        <InputActividadEconomica name="actividad_economica_rep" control={control} modelDef={omodel.model['actividad_economica_rep']} disabled={soloLectura} col={12} />
                        {inText('nombre_empresa_rep', { icon: 'pi pi-building' }, 4)}

                        {inText('cargo_rep', { icon: 'pi pi-id-card' }, 4)}
                        {inCalendar('fecha_inicio_laboral', {}, 4)}

                        {inDrop('pais_empresa', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePaisEmpresa }, ecuadorEmpresa ? 4 : 6)}

                        {ecuadorEmpresa ? (
                            <>
                                {inDrop('provincia_empresa', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvinciaEmpresa }, 4)}
                                {inDrop('ciudad_empresa', ciudadesEmpresa, { lab: omodel.optionLabel }, 4)}
                            </>
                        ) : (
                            inText('ciudad_empresa_txt', { icon: 'pi pi-map-marker' }, 6)
                        )}

                        <div className="col-12 mt-3 mb-2 border-bottom-1 border-300"><span className="text-primary font-bold">Información Financiera</span></div>

                        {inNumber('ingreso_mensual', 2, true, { icon: 'pi pi-plus-circle' }, 6)}
                        {inNumber('egreso_mensual', 2, true, { icon: 'pi pi-minus-circle' }, 6)}
                        {inNumber('total_activo_rep', 2, true, { icon: 'pi pi-chart-line' }, 6)}
                        {inNumber('total_pasivo_rep', 2, true, { icon: 'pi pi-chart-pie' }, 6)}
                    </div>
                </form>
            </Panel>

            <Panel header={generic.renderPanelHeader('E', 'ESTADO PATRIMONIAL (De la Persona Jurídica)', 'pi pi-users')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                <div className="p-3 mb-4 surface-100 border-round border-1 border-300">
                    <p className="m-0 mb-2 text-700">
                        <i className="pi pi-info-circle mr-2 text-primary"></i>
                        Favor suministrarnos la siguiente información en el caso de aquellos accionistas que superen el <strong>10% en su participación</strong>.
                    </p>
                    <p className="m-0 text-600 text-sm font-italic">
                        * Se debe detallar a todos los accionistas de la compañía. Si uno de los accionistas es una persona jurídica, ya sea nacional o extranjera, se debe adjuntar una hoja que contenga el detalle de sus accionistas y así hasta llegar a la persona natural.
                    </p>
                </div>
                <div className="p-2">
                    <EstadoPatrimonial id={id} tipo="clientePj" toast={toast} catalogos={catalogos} permss={permss} soloLectura={soloLectura} />
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('', 'INFORMACIÓN DE LA OPERACIÓN Y TRANSACCIÓN', 'pi pi-briefcase')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inDrop('tipo_estructura', catalogos?.tipo_estructura, { lab: omodel.optionLabel }, 4)}
                    {inDrop('tipo_bien', catalogos?.tipo_bien, { lab: omodel.optionLabel }, 4)}
                    {inNumber('monto', 2, true, { placeholder: 'Ej. 25000.00' }, 4)}
                    {inDrop('pais_bien', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePaisBien }, ecuadorBien ? 4 : 6)}
                    {ecuadorBien ? (
                        <>
                            {inDrop('provincia_bien', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvinciaBien }, 4)}
                            {inDrop('ciudad_bien', ciudadesBien, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('canton_bien', { placeholder: 'Ingrese la ciudad / cantón del bien o servicio', icon: 'pi pi-map-marker' }, 6)
                    )}
                    <div className="col-12 my-2">
                        <span className="text-700 font-bold text-sm flex align-items-center gap-2">
                            <i className="pi pi-credit-card text-primary"></i>
                            CANAL Y FORMA DE PAGO
                        </span>
                        <div className="border-top-1 border-300 mt-2"></div>
                    </div>
                    {inDrop('tipo_transaccion', catalogos?.tipo_transaccion, { lab: omodel.optionLabel }, 4)}
                    {inDrop('instrumento', catalogos?.instrumento, { lab: omodel.optionLabel }, 4)}
                    {inDrop('pais_fondo', catalogos?.pais, { lab: omodel.optionLabel }, 4)}
                    {inDrop('pais_canal', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePaisCanal }, ecuadorCanal ? 4 : 6)}
                    {ecuadorCanal ? (
                        <>
                            {inDrop('provincia_canal', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvinciaCanal }, 4)}
                            {inDrop('ciudad_canal', ciudadesCanal, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('canton_canal', { placeholder: 'Ingrese la ciudad / cantón del canal del servicio', icon: 'pi pi-map-marker' }, 6)
                    )}
                </div>
            </Panel>

            <BottomActionBar layoutVersion="v2" formId="datosLaboralesForm" onPrev={handlePrev} onNext={handleNext} loading={isSaving} isReadOnly={soloLectura} />
        </div>
    );
}